import React, { useEffect } from 'react';
import Add from './Add';
import Edit from './Edit';
import { useCountries } from './CountryStore';
import { MainTable } from '../../../Components/MainTable/MainTable';

function Countries(props) {
    let { countries, columns, getCountries, deleteCountry,setEd } = useCountries()
    useEffect(() => {
        getCountries()
    }, [])
    return (
        <MainTable
            pageTitle='Davlatlar'
            pcolumns={columns}
            pdata={countries}
            add={<Add />}
            edit={<Edit />}
            defkey={'id'}
            onDelete={(e, rec) => {
                deleteCountry(rec.id)
            }}
            onEdit={(rec) => {
                setEd(rec)
            }}
            setEd={setEd}
        />
    );
}

export default Countries;